import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 10.5L5.96967 11.0303L6.5 11.5607L7.03033 11.0303L6.5 10.5ZM15 8H14.25C14.25 11.4518 11.4518 14.25 8 14.25V15V15.75C12.2802 15.75 15.75 12.2802 15.75 8H15ZM8 15V14.25C4.54822 14.25 1.75 11.4518 1.75 8H1H0.25C0.25 12.2802 3.71979 15.75 8 15.75V15ZM1 8H1.75C1.75 4.54822 4.54822 1.75 8 1.75V1V0.25C3.71979 0.25 0.25 3.71979 0.25 8H1ZM8 1V1.75C11.4518 1.75 14.25 4.54822 14.25 8H15H15.75C15.75 3.71979 12.2802 0.25 8 0.25V1ZM4 8L3.46967 8.53033L5.96967 11.0303L6.5 10.5L7.03033 9.96967L4.53033 7.46967L4 8ZM6.5 10.5L7.03033 11.0303L12.0303 6.03033L11.5 5.5L10.9697 4.96967L5.96967 9.96967L6.5 10.5Z",
		fill: "currentColor"
	})
});
export default SvgCircleCheck;
